import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { Reimbursement } from "#/types/reimbursement"

const REIMBURSEMENTS_QUERY_KEY = "reimbursementsQueryKey"

export function useReimbursements<TData = Reimbursement[]>(
  options?: Pick<UseQueryOptions<Reimbursement[], ResponseError, TData>, "select" | "enabled">
): UseQueryResult<TData, ResponseError> {
  return useQuery<Reimbursement[], ResponseError, TData>({
    queryKey: [REIMBURSEMENTS_QUERY_KEY],
    queryFn: () => carrotClient.getReimbursements(),
    retry: buildCarrotApiRetryPolicy(3),
    ...(options ?? {})
  })
}
